import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import { VEHICLE_LIST_API, DRIVER_LIST_API, VEHICLE_DRIVER_SAVE } from '../../../config/api';
import { BsThreeDotsVertical } from 'react-icons/bs';
import DriverMenu from './DriverMenu';

function DriverInfoCard({ form, handleChange }) {
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [newDriver, setNewDriver] = useState({ vehicle_no: '', driver_name: '', mobile: '' });

  useEffect(() => {
    fetchVehicleOptions();
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setMenuOpen(false);
    }
  };

  const fetchVehicleOptions = async () => {
    try {
      const res = await fetch(VEHICLE_LIST_API);
      const data = await res.json();
      if (res.ok && Array.isArray(data)) {
        const options = data.map(v => ({
          value: v.vehicle_no.trim(),
          label: v.vehicle_no.trim()
        }));
        setVehicleOptions(options);
        const selected = options.find(opt => opt.value === form.vehicle_no);
        setSelectedVehicle(selected || null);
      }
    } catch (err) {
      console.error('Failed to fetch vehicle options:', err);
    }
  };

  const fetchDriversByVehicle = async (vehicle_no) => {
    try {
      const res = await fetch(DRIVER_LIST_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vehicle_no })
      });
      const data = await res.json();
      const options = (Array.isArray(data) ? data : []).map(d => ({
        value: d.driver_name,
        label: `${d.driver_name} (${d.mobile})`,
        mobile: d.mobile
      }));
      setDriverOptions(options);
    } catch (err) {
      console.error('Failed to fetch driver options:', err);
    }
  };

  const handleVehicleChange = (selected) => {
    setSelectedVehicle(selected);
    const selectedVehicleNo = selected?.value || '';
    handleChange({ target: { name: 'vehicle_no', value: selectedVehicleNo } });
    setSelectedDriver(null);
    handleChange({ target: { name: 'driver_name', value: '' } });
    handleChange({ target: { name: 'driver_mobile', value: '' } });

    if (selectedVehicleNo) {
      fetchDriversByVehicle(selectedVehicleNo);
    }
  };

  const handleDriverChange = (selected) => {
    setSelectedDriver(selected);
    handleChange({ target: { name: 'driver_name', value: selected?.value || '' } });
    handleChange({ target: { name: 'driver_mobile', value: selected?.mobile || '' } });
  };

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setNewDriver(prev => ({ ...prev, [name]: value }));
  };

  const handleModalSave = async () => {
    const { vehicle_no, driver_name, mobile } = newDriver;
    if (!vehicle_no || !driver_name) {
      alert('Vehicle No and Driver Name are required');
      return;
    }

    try {
      const res = await fetch(VEHICLE_DRIVER_SAVE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newDriver)
      });

      const result = await res.json();
      if (result.success) {
        alert('Driver saved successfully');
        setShowModal(false);
        setNewDriver({ vehicle_no: '', driver_name: '', mobile: '' });

        fetchVehicleOptions();
        if ((form.vehicle_no || '').trim() === vehicle_no.trim()) {
          fetchDriversByVehicle(vehicle_no);
        }
      } else {
        alert(result.error || 'Insert failed');
      }
    } catch (err) {
      alert('Server error');
      console.error(err);
    }
  };

  return (
    <div className="card mb-4 border-left-success shadow-sm">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="card-title text-success mb-0">Driver Information</h5>

          {/* ⋮ Context Menu Button */}
         <DriverMenu
  onAdd={() => setShowModal(true)}
  onRefresh={fetchVehicleOptions}
/>
        </div>

        <div className="row g-3">
          {/* Vehicle No */}
          <div className="col-md-3">
            <label className="form-label">Vehicle No</label>
            <Select
              options={vehicleOptions}
              value={selectedVehicle}
              onChange={handleVehicleChange}
              placeholder="Select Vehicle No"
              isClearable
            />
          </div>

          {/* Driver Name */}
          <div className="col-md-4">
            <label className="form-label">Driver Name</label>
            <Select
              options={driverOptions}
              value={selectedDriver}
              onChange={handleDriverChange}
              placeholder="Select Driver"
              isClearable
            />
          </div>

          {/* Driver Mobile */}
          <div className="col-md-4">
            <label className="form-label">Driver Mobile</label>
            <input
              type="text"
              name="driver_mobile"
              className="form-control"
              value={form.driver_mobile || ''}
              onChange={handleChange}
              placeholder="Mobile will auto-fill"
              readOnly
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: '#00000066' }}>
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content p-3">
              <div className="modal-header">
                <h5 className="modal-title">Add Driver</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body">
                <input name="vehicle_no" className="form-control mb-2" placeholder="Vehicle No" value={newDriver.vehicle_no} onChange={handleModalChange} />
                <input name="driver_name" className="form-control mb-2" placeholder="Driver Name" value={newDriver.driver_name} onChange={handleModalChange} />
                <input name="mobile" className="form-control mb-2" placeholder="Mobile No" value={newDriver.mobile} onChange={handleModalChange} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-success btn-sm" onClick={handleModalSave}>Save</button>
                <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DriverInfoCard;
